import { React, useEffect, useState } from "react";
import cryptologo from "../images/logos/cryptools-low-resolution-logo-black-on-transparent-background.png";
import ButtonPrimary from "./Button-primary";
import ButtonWarning from "./Button-warning";

const Header = () => {
  // const [isOpen, setIsOpen] = useState(false);
  const [isConnected, setIsConnected] = useState(false);
  const [state, setState] = useState(false);
  const [isLoggedOut, setIsLoggedOut] = useState(false);

  //check if isConnected is yes in localStorage
  useEffect(() => {
    if (localStorage.getItem("isConnected") === "yes") {
      setIsConnected(true);
    }
  }, []);

  const navigation = [
    { title: "Unit Price Calculator", path: "/transactions" },
    { title: "Balance", path: "/balance" },
    { title: "Amount received", path: "/how-much-received" },
    { title: "Private Key Generator", path: "/private-key" },
    { title: "Futures", path: "/futures" },
    { title: "Delta Neutral", path: "/delta-neutral" },
    { title: "IL Checker", path: "/il-checker" },
    { title: "Time Machine", path: "/time-machine" },
  ];

  const logout = async () => {
    try {
      localStorage.removeItem("token");
      localStorage.removeItem("isConnected");
      setIsConnected(false);
      setIsLoggedOut(true);
      setTimeout(() => {
        setIsLoggedOut(false);
        window.location.href = "/";
      }, 1000);
    } catch (error) {
      console.error(error);
    }
  };

  const handleLogout = () => {
    if (window.confirm("Are you sure you want to log out?")) {
      logout();
    }
  };

  return (
    <>
      <header className="sticky top-0 bg-white z-[300] mb-10 shadow">
        <nav className="items-center px-4 pt-5 mx-auto max-w-screen-xl sm:px-8 lg:flex lg:space-x-6">
          <div className="flex justify-between">
            <a href="/">
              <img
                src={cryptologo}
                width={120}
                height={50}
                alt="Cryptools logo"
              />
            </a>
            <button
              className="text-gray-500 outline-none lg:hidden"
              onClick={() => setState(!state)}>
              {state ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-6 h-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-6 h-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              )}
            </button>
          </div>
          <ul
            className={`flex-1 justify-between mt-0 lg:text-sm lg:font-medium lg:flex lg:mt-0 ${
              state
                ? "absolute inset-x-0 px-4 py-10 bg-white border-b lg:border-none lg:static"
                : "hidden"
            }`}>
            <div className="items-center space-y-5 lg:flex lg:space-x-6 lg:space-y-0 lg:ml-12">
              {navigation.map((item, idx) => (
                <li className="text-gray-500 hover:text-indigo-600" key={idx}>
                  <a href={item.path}>{item.title}</a>
                </li>
              ))}
            </div>
            {isConnected === false && (
              <li className="order-2 py- lg:py-0">
                <a
                  href="/register"
                  className="block px-5 py-2 font-medium text-center text-white bg-indigo-600 rounded-lg duration-150 hover:bg-indigo-500 active:bg-indigo-700 lg:py-3 lg:inline lg:mr-4 lg:mb-0">
                  Register
                </a>
                <a
                  href="/login"
                  className="block px-5 py-2 font-medium text-center text-gray-500 rounded-lg border duration-150 hover:text-indigo-600 hover:shadow lg:py-3 lg:inline">
                  Login
                </a>
              </li>
            )}
            {isConnected === true && (
              <li className="flex order-2 gap-2 mt-8 py- lg:py-0 lg:mt-0">
                <ButtonPrimary
                  text={"Dashboard"}
                  link={"/dashboard"}
                  className={"px-5 py-2 lg:inline"}
                />
                <ButtonWarning
                  text={"Logout"}
                  link={"/"}
                  className={"px-5 py-2 lg:inline"}
                  func={handleLogout}
                />
                {isLoggedOut && (
                  <div>
                    <p>You have been logged out.</p>
                    <p>Redirecting to dashboard in 3 seconds...</p>
                  </div>
                )}
              </li>
            )}
          </ul>
        </nav>
      </header>
    </>
  );
};

export default Header;
